import React from 'react';
import { ListGroup, Row, Col } from 'react-bootstrap';

import CentralLink from './CentralLink.js';
import GoverningBodyFlag from './GoverningBodyFlag.js';

import { OperationalCatchmentsLinkCalculator } from '../lib/LinkCalculators.js';

const RiverOperationalCatchments = ({ catchments }) => {

  // Sort by name alphabetically
  let sortedCatchments = [];
  try {
    sortedCatchments = [...catchments].sort((a, b) => a.operCatchmentName.localeCompare(b.operCatchmentName));
  } catch(err) {
    console.error(err, sortedCatchments);
  }

  return (
    <ListGroup>
      <ListGroup.Item variant="dark" className="bg-dark text-white">
        Operational Catchment Areas
      </ListGroup.Item>
      {sortedCatchments.map(function(catchment) {
        return <CentralLink to={OperationalCatchmentsLinkCalculator(catchment.operCatchmentName)} key={catchment.operCatchmentId}>
          <ListGroup.Item action>
            <Row>
              <Col xs={0} md={1} className="d-none d-md-block"></Col>
              <Col xs={8} md={10}>{catchment.operCatchmentName}</Col>
              <Col xs={4} md={1}><GoverningBodyFlag governingBody={catchment.governingBody} /></Col>
            </Row>
          </ListGroup.Item>
        </CentralLink>
      })}
    </ListGroup>
  );
};

export default RiverOperationalCatchments;
